import { render } from "./login.vue?vue&type=template&id=9af3dac2&scoped=true&ts=true"
import script from "./login.ts?vue&type=script&lang=ts"
export * from "./login.ts?vue&type=script&lang=ts"

import "./login.scss?vue&type=style&index=0&id=9af3dac2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af3dac2"]])

export default __exports__